import React from 'react';
import Link from "next/link";

const ReadyToStart = ({t}) => {

    const ready = t('common:ready', {}, {returnObjects: true});

    return (
        <section className={'ready_to_start'}>
            <div className="container">
                <div className="ready_content" >
                    <picture>
                        <source
                            media="(max-width: 768px)"
                            srcSet={`/img/commons/ready_bg_small.png`}
                        />
                        <source
                            media="(min-width: 769px)"
                            srcSet={`/img/commons/ready_bg.png`}
                        />
                        <img
                            src={`/img/commons/ready_bg.png`}
                            alt={`Ready to Coldware`}
                            width={1280}
                            height={290}
                            className='ready_content_bg'
                        />
                    </picture>
                    <h2 className={'ready_content_title'}>{ready.title}</h2>
                    <Link className={'ready_content_cta'} href={process.env.NEXT_PUBLIC_APP_URL}>
                        {ready.cta}
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default ReadyToStart;